var map = {
	"./Dashboard.vue": "ec95",
	"./DataExport.vue": "342a",
	"./admin/mypos/Unauthorized.vue": "5510",
	"./admin/mypos/adjustments.vue": "a9b1",
	"./admin/mypos/branch-form.vue": "5130",
	"./admin/mypos/branch-management.vue": "8495",
	"./admin/mypos/branchReports.vue": "f21f",
	"./admin/mypos/branch_target_form.vue": "8666",
	"./admin/mypos/branch_targets.vue": "a43c",
	"./admin/mypos/branchleague.vue": "dddd",
	"./admin/mypos/cashierform.vue": "b8bc",
	"./admin/mypos/cashiers.vue": "3fec",
	"./admin/mypos/categories.vue": "2fd3",
	"./admin/mypos/categoryform.vue": "8474",
	"./admin/mypos/claims.vue": "8ab8",
	"./admin/mypos/collectionreports.vue": "d1d6",
	"./admin/mypos/collections.vue": "bcd2",
	"./admin/mypos/credit_form.vue": "7222",
	"./admin/mypos/credits.vue": "f90d",
	"./admin/mypos/csv.vue": "de82",
	"./admin/mypos/customerform.vue": "0fc2",
	"./admin/mypos/customers.vue": "4bb0",
	"./admin/mypos/deliveries.vue": "b36c",
	"./admin/mypos/deliverynote.vue": "926c",
	"./admin/mypos/dispatchplanner.vue": "8db4",
	"./admin/mypos/expenseReports.vue": "c607",
	"./admin/mypos/expenseform.vue": "0672",
	"./admin/mypos/expenses.vue": "c267",
	"./admin/mypos/franchise-detail-form.vue": "d6b8",
	"./admin/mypos/franchise-management.vue": "a587",
	"./admin/mypos/franchisee-bill-details.vue": "997d",
	"./admin/mypos/franchisee-bills.vue": "5189",
	"./admin/mypos/inbounds.vue": "aaf8",
	"./admin/mypos/inboundstock.vue": "b02c",
	"./admin/mypos/internaltransfer.vue": "4840",
	"./admin/mypos/intransfers.vue": "41fb",
	"./admin/mypos/invoice_history.vue": "f81f",
	"./admin/mypos/location-form.vue": "7dc3",
	"./admin/mypos/location-management.vue": "c48e",
	"./admin/mypos/materialrequest.vue": "136b",
	"./admin/mypos/orders.vue": "eedd",
	"./admin/mypos/poform.vue": "2c44",
	"./admin/mypos/pos.vue": "09c6",
	"./admin/mypos/printcollection.vue": "7a6d",
	"./admin/mypos/printinternaltransfer.vue": "2519",
	"./admin/mypos/printinvoice.vue": "7c17",
	"./admin/mypos/printpo.vue": "a93c",
	"./admin/mypos/productform.vue": "2656",
	"./admin/mypos/products.vue": "f4eb",
	"./admin/mypos/purchase.vue": "240b",
	"./admin/mypos/purchaseorders.vue": "b8d2",
	"./admin/mypos/reports.vue": "5759",
	"./admin/mypos/reports2.vue": "436e",
	"./admin/mypos/salesmenleague.vue": "4a7c",
	"./admin/mypos/settings.vue": "59d5",
	"./admin/mypos/stock.vue": "399e",
	"./admin/mypos/stockadjustment.vue": "fec0",
	"./admin/mypos/stockcalculation.vue": "8cab",
	"./admin/mypos/supplierform.vue": "335d",
	"./admin/mypos/suppliers.vue": "2c79",
	"./admin/mypos/task_form.vue": "91f3",
	"./admin/mypos/tasks.vue": "09a7",
	"./admin/mypos/totalstock.vue": "ac40",
	"./admin/mypos/trade_card.vue": "1f5b",
	"./admin/mypos/tradecardform.vue": "3cbc",
	"./admin/mypos/transferguide.vue": "47ce",
	"./admin/mypos/welcomenote.vue": "3531",
	"./admin/permissions/Permissions.vue": "ab82",
	"./admin/roles/Roles.vue": "e590",
	"./admin/users/CreateUser.vue": "6847",
	"./admin/users/EditUser.vue": "2754",
	"./admin/users/Users.vue": "95fd",
	"./errors/404.vue": "22dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a823";